import { LockOutlined, Visibility, VisibilityOff } from "@mui/icons-material";
import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput
} from "@mui/material";
import React, { useState } from "react";
import { FieldErrors } from "react-hook-form";

interface InputFieldProps {
  name: string;
  label: string;
  error?: FieldErrors;
}

export const PasswordField = React.forwardRef<
  HTMLInputElement,
  InputFieldProps
>((props, ref) => {
  const { error, label, name, ...rest } = props;
  const [show, setShow] = useState(false);

  const handleClickShowPassword = () => {
    setShow((prev) => !prev);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    // <FormControl position="relative" isInvalid={!!error}>
    <FormControl id={name} variant="outlined" fullWidth sx={{ my: 1 }}>
      <InputLabel htmlFor="outlined-adornment-password">{label}</InputLabel>
      <OutlinedInput
        id="outlined-adornment-password"
        type={show ? "text" : "password"}
        label="Password"
        required
        fullWidth
        autoComplete="current-password"
        error={!!error}
        startAdornment={
          <InputAdornment position="start">
            <LockOutlined />
          </InputAdornment>
        }
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {show ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
        {...rest}
      />
      {error && (
        <FormHelperText error>{error["message"] as any}</FormHelperText>
      )}
    </FormControl>
  );
});

PasswordField.displayName = "PasswordField";
